import Button from 'semantic-ui-react/dist/es/elements/Button';
import './Button.css';

export default Button;
